<template>
    <div class="sys-update-info-wrap">
        <p class="system-update-text" @click="seeUpdateInfo">
            通知：本月，平台财务系统将完成升级，本次升级后…  >
        </p>
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        methods: {
            // 点击通知升级
            seeUpdateInfo(){
                const content = `<b>通知：本月，平台财务系统将完成升级，本次升级后：</b><br/>
    1、提现无限额；<br/>
    2、豆包账户将不再支持支付宝提现方式；<br/>
    3、豆包账户将只支持银行卡提现方式；<br/>
    4、新添加银行卡账户需进行人脸验证；<br/>
    5、原已绑定银行卡账户需重新进行人脸验证；<br/>
    6、同一个实名身份最多可添加3张银行卡。`
                this.$alert(content, '提示', {
                    dangerouslyUseHTMLString: true
                });
            },
        }
    }
</script>

<style lang="less" scoped>
.sys-update-info-wrap{
    .system-update-text{
        font-size: 14px;
        color: red; 
        cursor: pointer;
        padding: 0 0 10px;
    }
}
</style>